// Constantes relacionadas a APIs e catálogo de APIs

// APIs (versão nova com Scalar)
export const Apis = [
  {
    id: '1',
    name: 'Authentication',
    description: 'Descrição de Authentication',
    version: '1.2.0',
    status: 'active',
    updatedAt: '2025-01-15T10:30:00Z',
    fileName: 'cognito-requests.json',
    productId: 1,
    applicationId: [1, 2, 3, 4, 5],
    capabilityId: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  },
  {
    id: '2',
    name: 'Collection Receivement',
    description: 'A Collection Receivement API padroniza o processamento de cobranças digitais no ecossistema da LWSA, oferecendo uma interface única para recebimentos, independentemente da adquirente ou do método de pagamento utilizado.',
    version: '1.0.0',
    status: 'active',
    fileName: 'collection-receivement.json',
    updatedAt: '2024-02-01T15:45:00Z',
    productId: 1,
    applications: [2],
    capabilityId: [1]
  },
  {
    id: '3',
    name: 'Provisioning Connector',
    description: 'A Provisioning Connector API funciona como um hub de integração para o provisionamento de produtos e serviços digitais, coordenando o ciclo completo entre sistemas de billing e entrega de forma ágil e escalável.',
    version: '1.0.0',
    status: 'active',
    fileName: 'provisioning-connector-api.json',
    updatedAt: '2025-01-10T15:45:00Z',
    productId: 1,
    applications: [3],
    capabilityId: [1]
  },      
  {
    id: '4',
    name: 'Roteirizador',
    description: 'Descrição da Roteirizador',
    version: '1.0.0',
    status: 'active',
    fileName: 'roteirizador.json',
    updatedAt: '2025-05-10T15:45:00Z',
    productId: 2,
    applications: [8],
    capabilityId: [10, 11]
  },     
  {
    id: '5',
    name: 'Omnichannel - Customer API',
    description: 'A Omnichannel Customer API atua como uma camada de orquestração para dados e processos de clientes, consolidando interações entre múltiplos sistemas internos por meio de uma interface moderna que cobre todo o ciclo de vida do cliente.',
    version: '1.0.0',
    status: 'active',
    fileName: 'customer-api.json',
    updatedAt: '2024-01-10T15:45:00Z',
    productId: 1,
    applications: [1],
    capabilityId: [1]
  },
  {
    id: '6',
    name: 'Omnichannel - Contract API',
    description: 'A Omnichannel Contract API oferece uma abordagem integrada para o gerenciamento de contratos, reunindo em uma única interface as operações relacionadas a faturamento, provisionamento de serviços e gestão comercial.',
    version: '1.0.0',
    status: 'deprecated',
    fileName: 'contract-api.json',
    updatedAt: '2024-01-05T12:30:00Z',
    productId: 1,
    applications: [1],
    capabilityId: [1]
  },
  {
    id: '7',
    name: 'Omnichannel - Order API',
    description: 'A Omnichannel Order API organiza e controla todo o ciclo de vida de pedidos e contratos, desde a criação até a cobrança e o provisionamento, garantindo consistência entre os sistemas da organização por meio de uma interface unificada.',
    version: '1.0.0',
    status: 'deprecated',
    fileName: 'order-api.json',
    updatedAt: '2024-01-05T12:30:00Z',
    productId: 1,
    applications: [1],
    capabilityId: [1]
  },
  {
    id: '8',
    name: 'Omnichannel - Catalog API',
    description: 'A Omnichannel Catalog API fornece uma interface centralizada para gerenciar e consultar informações de catálogo, incluindo produtos, serviços, preços e disponibilidade, garantindo consistência e eficiência na gestão de informações comerciais.',
    version: '1.0.0',
    status: 'active',
    fileName: 'catalog-api.json',
    updatedAt: '2024-01-05T12:30:00Z',
    productId: 1,
    applications: [1],
    capabilityId: [1]
  }
]

// APIs (versão antiga)
export const mockApis = [
  {
    id: '1',
    name: 'Users API',
    description: 'API para gerenciamento de usuários',
    version: '1.2.0',
    status: 'active',
    baseUrl: 'https://api.lwsa.com/users',
    updatedAt: '2024-01-15T10:30:00Z',
    endpoints: [
      {
        id: 'e1',
        method: 'GET',
        path: '/users',
        description: 'Listar todos os usuários',
        parameters: [
          { name: 'page', type: 'integer', required: false },
          { name: 'limit', type: 'integer', required: false }
        ]
      },
      {
        id: 'e2',
        method: 'POST',
        path: '/users',
        description: 'Criar novo usuário',
        parameters: [
          { name: 'name', type: 'string', required: true },
          { name: 'email', type: 'string', required: true }
        ]
      }
    ],
    schemas: [
      {
        name: 'User',
        definition: {
          type: 'object',
          properties: {
            id: { type: 'string' },
            name: { type: 'string' },
            email: { type: 'string' }
          }
        }
      }
    ],
    examples: [
      {
        id: 'ex1',
        title: 'Buscar usuários',
        code: 'GET /users?page=1&limit=10'
      }
    ]
  },
  {
    id: '2',
    name: 'Products API',
    description: 'API para catálogo de produtos',
    version: '2.1.0',
    status: 'active',
    baseUrl: 'https://api.lwsa.com/products',
    updatedAt: '2024-01-10T15:45:00Z',
    endpoints: [
      {
        id: 'e3',
        method: 'GET',
        path: '/products',
        description: 'Listar produtos',
        parameters: []
      }
    ],
    schemas: [],
    examples: []
  },
  {
    id: '3',
    name: 'Orders API',
    description: 'API para gerenciamento de pedidos',
    version: '1.0.0',
    status: 'deprecated',
    baseUrl: 'https://api.lwsa.com/orders',
    updatedAt: '2024-01-05T12:30:00Z',
    endpoints: [
      {
        id: 'e4',
        method: 'GET',
        path: '/orders',
        description: 'Listar pedidos',
        parameters: []
      }
    ],
    schemas: [],
    examples: []
  }
]

// Estatísticas mock das APIs
export const mockStats = {
  totalApis: 12,
  activeApis: 10,
  deprecatedApis: 25
}